import {IconName} from '../../../../app/components/Icons/Icon'

export type SideBarData = {
  icon?: IconName
  text: string
  href: string
  badge?: string
  subItems?: SideBarData[]
  refresh?: boolean
}

// const unreadCount: string = useSelector((state: any) => state.auth.Unread)

export const sidebarDataCombined: SideBarData[] = [
  {
    href: '/home',
    icon: 'home',
    text: 'Home'
  },
  {
    href: '/news',
    icon: 'world',
    text: 'News'
  },
  {
    href: '/blogs',
    icon: 'article',
    text: 'Blogs'
  },
  {
    href: '/my-plans',
    icon: 'checklist',
    text: 'My plans'
  },
  {
    href: '/messages',
    icon: 'email',
    text: 'Messages'
    //badge: unreadCount as string
  },
  {
    href: 'https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=fsbp',
    icon: 'doctor',
    text: 'Find a Doctor',
    refresh: true
  },
  {
    href: '/request-forms',
    icon: 'add-doc',
    text: 'Request Forms',
    subItems: [
      {
        text: 'Submit a Claim',
        href: '/submit-claim'
      },
      {
        text: 'Submit an Incentive',
        href: '/submit-incentive'
      },
      {
        text: 'Meet with HBO in Person (Health Plan)',
        href: 'https://outlook.office.com/book/AFSPAInPersonMeeting@afspa365.onmicrosoft.com/',
        refresh: true
      },
      {
        text: 'Meet with AIP/SLF in Person',
        href: 'https://book.ms/b/AIPInPersonMeeting@afspa365.onmicrosoft.com',
        refresh: true
      }
    ]
  },
  {
    href: '/claims-history',
    icon: 'notes-clock',
    text: 'Claims History'
  },
  {
    href: '/incentives-history',
    icon: 'notes-star',
    text: 'Incentives History'
  },
  {
    href: '/directdebit',
    icon: 'plus',
    text: 'Direct Debit'
  },
  {
    href: '/profileform',
    icon: 'person',
    text: 'Profile'
  },
  {
    href: '/downloads',
    icon: 'doc',
    text: 'Downloads'
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/logout',
    icon: 'log-out',
    text: 'Logout'
  }
]

export const sidebarDataFSBP: SideBarData[] = [
  {
    href: '/home',
    icon: 'home',
    text: 'Home'
  },
  {
    href: '/news',
    icon: 'world',
    text: 'News'
  },
  {
    href: '/blogs',
    icon: 'article',
    text: 'Blogs'
  },
  {
    href: '/my-plans',
    icon: 'checklist',
    text: 'My plans'
  },
  {
    href: '/messages',
    icon: 'email',
    text: 'Messages'
    //badge: unreadCount as string
  },
  {
    href: 'https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=fsbp',
    icon: 'doctor',
    text: 'Find a Doctor',
    refresh: true
  },
  {
    href: '/request-forms',
    icon: 'add-doc',
    text: 'Request Forms',
    subItems: [
      {
        text: 'Submit a Claim',
        href: '/submit-claim'
      },
      {
        text: 'Submit an Incentive',
        href: '/submit-incentive'
      },
      {
        text: 'Meet with HBO in Person',
        href: 'https://outlook.office.com/book/AFSPAInPersonMeeting@afspa365.onmicrosoft.com/',
        refresh: true
      }
    ]
  },
  {
    href: '/claims-history',
    icon: 'notes-clock',
    text: 'Claims History'
  },
  {
    href: '/incentives-history',
    icon: 'notes-star',
    text: 'Incentives History'
  },
  {
    href: '/profileform',
    icon: 'person',
    text: 'Profile'
  },
  {
    href: '/downloads',
    icon: 'doc',
    text: 'Downloads'
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/logout',
    icon: 'log-out',
    text: 'Logout'
  }
]

export const sidebarDataCombinedNoClaim: SideBarData[] = [
  {
    href: '/home',
    icon: 'home',
    text: 'Home'
  },
  {
    href: '/news',
    icon: 'world',
    text: 'News'
  },
  {
    href: '/blogs',
    icon: 'article',
    text: 'Blogs'
  },
  {
    href: '/my-plans',
    icon: 'checklist',
    text: 'My plans'
  },
  {
    href: '/messages',
    icon: 'email',
    text: 'Messages'
    //badge: unreadCount as string
  },
  {
    href: 'https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=fsbp',
    icon: 'doctor',
    text: 'Find a Doctor',
    refresh: true
  },
  {
    href: '/request-forms',
    icon: 'add-doc',
    text: 'Request Forms',
    subItems: [
      {
        text: 'Meet with HBO in Person (Health Plan)',
        href: 'https://outlook.office.com/book/AFSPAInPersonMeeting@afspa365.onmicrosoft.com/',
        refresh: true
      },
      {
        text: 'Meet with AIP/SLF in Person',
        href: 'https://book.ms/b/AIPInPersonMeeting@afspa365.onmicrosoft.com',
        refresh: true
      }
    ]
  },
  {
    href: '/claims-history',
    icon: 'notes-clock',
    text: 'Claims History'
  },
  {
    href: '/incentives-history',
    icon: 'notes-star',
    text: 'Incentives History'
  },
  // {
  //   href: '/request1095b-history',
  //   icon: 'doc',
  //   text: 'Request 1095B History'
  // },
  // {
  //   href: '/payments',
  //   icon: 'credit-card',
  //   text: 'AIP Payments History'
  // },
  {
    href: '/directdebit',
    icon: 'plus',
    text: 'Direct Debit'
  },
  {
    href: '/profileform',
    icon: 'person',
    text: 'Profile'
  },
  {
    href: '/downloads',
    icon: 'doc',
    text: 'Downloads'
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/logout',
    icon: 'log-out',
    text: 'Logout'
  }
]

export const sidebarDataFSBPNoClaim: SideBarData[] = [
  {
    href: '/home',
    icon: 'home',
    text: 'Home'
  },
  {
    href: '/news',
    icon: 'world',
    text: 'News'
  },
  {
    href: '/blogs',
    icon: 'article',
    text: 'Blogs'
  },
  {
    href: '/my-plans',
    icon: 'checklist',
    text: 'My plans'
  },
  {
    href: '/messages',
    icon: 'email',
    text: 'Messages'
    //badge: unreadCount as string
  },
  {
    href: 'https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=fsbp',
    icon: 'doctor',
    text: 'Find a Doctor',
    refresh: true
  },
  {
    href: '/request-forms',
    icon: 'add-doc',
    text: 'Request Forms',
    subItems: [
      {
        text: 'Meet with HBO in Person',
        href: 'https://outlook.office.com/book/AFSPAInPersonMeeting@afspa365.onmicrosoft.com/',
        refresh: true
      }
    ]
  },
  {
    href: '/claims-history',
    icon: 'notes-clock',
    text: 'Claims History'
  },
  {
    href: '/incentives-history',
    icon: 'notes-star',
    text: 'Incentives History'
  },
  {
    href: '/profileform',
    icon: 'person',
    text: 'Profile'
  },
  {
    href: '/downloads',
    icon: 'doc',
    text: 'Downloads'
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/logout',
    icon: 'log-out',
    text: 'Logout'
  }
]

export const sidebarDataNonFSBP: SideBarData[] = [
  {
    href: '/home',
    icon: 'home',
    text: 'Home'
  },
  {
    href: '/news',
    icon: 'world',
    text: 'News'
  },
  {
    href: '/blogs',
    icon: 'article',
    text: 'Blogs'
  },
  {
    href: '/my-plans',
    icon: 'checklist',
    text: 'My plans'
  },
  {
    href: '/messages',
    icon: 'email',
    text: 'Messages'
    //badge: unreadCount as string
  },
  {
    href: '/request-forms',
    icon: 'add-doc',
    text: 'Request Forms',
    subItems: [
      {
        text: 'Meet with AIP/SLF in Person',
        href: 'https://book.ms/b/AIPInPersonMeeting@afspa365.onmicrosoft.com',
        refresh: true
      }
    ]
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/payments',
    icon: 'credit-card',
    text: 'AIP Payments History'
  },
  {
    href: '/directdebit',
    icon: 'plus',
    text: 'Direct Debit'
  },
  {
    href: '/profileform',
    icon: 'person',
    text: 'Profile'
  },
  {
    href: '/seniorlivingfoundation',
    icon: 'heart',
    text: 'Senior Living Foundation'
  },
  {
    href: '/logout',
    icon: 'log-out',
    text: 'Logout'
  }
]
